import {ValueObject} from '@s-ui/domain'

export class VersionInfoValueObject extends ValueObject {
  /**
   * @param {Object} versionInfo
   * @param {Array<ImageValueObject>} versionInfo.images
   * @param {Array<MarketedVersionValueObject>} versionInfo.marketedVersions
   * @param {Object} versionInfo.specifications
   * @param {Number} versionInfo.year
   * @param {Array<MarketedYearValueObject>} versionInfo.availableMarketedYears
   * @param {Number} versionInfo.makeId
   * @param {Number} versionInfo.modelId
   * @param {Number} versionInfo.price
   * @param {String} versionInfo.initMarketedDate
   * @param {String} versionInfo.make
   * @param {String} versionInfo.model
   * @param {String} versionInfo.bodyType
   * */
}
